import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../material.module';
import { OrganizationsModule } from '../organizations/organizations.module';
import { ReactiveFormsModule } from '@angular/forms';
import { PublishModule } from '../publish/publish.module';
import { BookmarksModule } from '../bookmarks/bookmarks.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DashboardMessageComponent } from './components/dashboard-message/dashboard-message.component';
import { GalleryModule } from '../gallery/gallery.module';

@NgModule({
  imports: [
    MaterialModule,
    CommonModule,
    DashboardRoutingModule,
    OrganizationsModule,
    SharedModule,
    ReactiveFormsModule,
    PublishModule,
    BookmarksModule,
    FontAwesomeModule,

    GalleryModule
  ],
  declarations: [DashboardComponent, DashboardMessageComponent]
})
export class DashboardModule { }
